import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { applyCoupons, fetchCartPrices, fetchCoupons, removeAllCoupons, selectCouponCodes, useDispatch, useSelector, } from "@jti/store";
import { CheckOutSteps } from "../../constants/checkout-constants";
import formatCode from "../../utils/formatCode";
import { PromoCodeView } from "./components/PromoCodeView";
export const PromoCode = ({ step }) => {
    const dispatch = useDispatch();
    const cartId = useSelector((state) => state.cart.id);
    const couponCodes = useSelector(selectCouponCodes);
    const coupons = useSelector((state) => state.cart.coupons);
    const errors = useSelector((state) => state.cart.couponErrors);
    useEffect(() => {
        if (cartId) {
            dispatch(fetchCoupons(cartId));
        }
    }, [cartId, dispatch]);
    const handleAddCoupon = useCallback(async (couponCode) => {
        if (cartId) {
            await dispatch(applyCoupons({ cartId, couponCode: [...couponCodes, formatCode(couponCode)] }));
            dispatch(fetchCartPrices(cartId));
        }
    }, [cartId, couponCodes, dispatch]);
    const handleRemoveAllCoupons = useCallback(async () => {
        if (cartId) {
            await dispatch(removeAllCoupons(cartId));
            dispatch(fetchCoupons(cartId));
            dispatch(fetchCartPrices(cartId));
        }
    }, [cartId, dispatch]);
    const handleRemoveCoupon = useCallback(async (couponCode) => {
        if (cartId) {
            const updatedCouponCodes = couponCodes.filter((code) => code !== couponCode);
            // We need to remove coupon from coupons list and set new coupons list.
            // If we have only one coupon - it means we need to remove all copons from cart
            // because we can't apply empty list of coupons.
            if (updatedCouponCodes.length > 0) {
                await dispatch(applyCoupons({ cartId, couponCode: updatedCouponCodes }));
            }
            else {
                await dispatch(removeAllCoupons(cartId));
            }
            dispatch(fetchCoupons(cartId));
            dispatch(fetchCartPrices(cartId));
        }
    }, [cartId, couponCodes, dispatch]);
    if (step === CheckOutSteps.Payment) {
        return null;
    }
    return (_jsx(PromoCodeView, { errors: errors, items: coupons, onAddCoupon: handleAddCoupon, onRemoveAllCoupons: handleRemoveAllCoupons, onRemoveCoupon: handleRemoveCoupon }));
};
//# sourceMappingURL=PromoCode.js.map